import { Text } from '../../ui'
import { cn } from '../../../lib/cn'

type SettingsSectionProps = {
  id: string
  title: string
  description?: string
  children: React.ReactNode
  className?: string
}

export function SettingsSection({
  id,
  title,
  description,
  children,
  className,
}: SettingsSectionProps) {
  return (
    <section
      id={id}
      className={cn('py-2 md:py-4', className)}
    >
      <div className="mb-5">
        <Text variant="h1" className="text-xl md:text-2xl">
          {title}
        </Text>
        {description && (
          <Text variant="body-sm" className="mt-1 text-foreground/50">
            {description}
          </Text>
        )}
      </div>
      {children}
    </section>
  )
}
